import _ from 'lodash';
import moment from 'moment';
import { select } from 'redux-saga/effects';
import { createStandardAction } from 'typesafe-actions';

import { Locale, locales } from '../providers/LanguageProvider';
import { Language, UserBase } from '../resources/types';
import { selectCurrentUser } from '../selectors';
import storage from '../services/storageService';

const changeLocale = createStandardAction('@lib/changeLocale')<Locale>();

export const normalizeLocale = (value?: Locale | Language): Locale => {
  let locale = value || Locale.EnglishUS;

  // Convert language to locale
  if (value === Language.English) {
    locale = Locale.EnglishUS;
  } else if (value === Language.Spanish) {
    locale = Locale.SpanishUS;
  } else if (value === Language.Portuguese) {
    locale = Locale.PortugueseBR;
  }
  // Default to English in case the locale is not supported
  if (!_.includes(locales, locale)) {
    locale = Locale.EnglishUS;
  }
  return locale as Locale;
};

export function* sagaChangeLocale(action: ReturnType<typeof changeLocale>) {
  const { payload } = action;

  // WORKAROUND: Ensure we use locale instead of language
  // TODO: Remove once all files calling this are type-safe
  const locale = normalizeLocale(payload);

  // Configure Moment with new locale
  moment.locale(locale);
  const { remove: storageRemove, set: storageSet, getLocaleKeyByUserId } = storage;

  // Update locale on storage to use it next time user enters
  const currentUser: UserBase = yield select(selectCurrentUser);

  const localeKey = getLocaleKeyByUserId(_.get(currentUser, 'id', ''));

  const currentUserLocale = _.get(currentUser, 'language');
  if (locale === currentUserLocale) {
    storageRemove(localeKey);
  } else {
    storageSet(localeKey, locale);
  }
}

export default changeLocale;
